import { Pagination, styled } from '@mui/material';

const StyledPagination = styled(Pagination)(({ theme }) => ({
'& .ERPItem':{
    width: theme.spacing(5),
    height: theme.spacing(5),
    margin: theme.spacing(0, 0.75),
    fontSize: theme.spacing(1.75),
    lineHeight: theme.spacing(2.5),
    '&.Mui-selected':{
        backgroundColor: theme.palette.background.secondary,
        border: `1px solid ${theme.palette.divider[4]}`
    },
    '&.MuiPaginationItem-previousNext':{
        backgroundColor: theme.palette.background.secondary,
        border: `1px solid ${theme.palette.divider[4]}`
    },
    '&.Mui-disabled':{
        opacity:'unset',
        backgroundColor:'unset',
        color: theme.palette.text.disabled,
    },
},
}));
export default StyledPagination;
